export enum LoginType {
    Member = 'Member',
    Counselor = 'Counselor',
    FirstResponder = 'FirstResponder',
    Registration = 'Registration',
    NewPassword = 'NewPassword',
    ResetPassword = 'ResetPassword',
    AccountDeleted = 'AccountDeleted',
    Passthrough ='Passthrough',
}

export enum LoginMode {
    Credenttials,
    CredenttialsCounselor,
    Registration,
    ResetPassword,
    Passthrough,
    MFA,
    SelectAccount,
    AccountDeleted
}